export default __webpack_public_path__ + "static/media/img-project_2.3784fc08.jpg";